import { vsingleton } from '@niknevis/vue-modules'

@vsingleton()
export default class CountDownStore {
  seconds = null
  interval = null
  timer = ''
  expired = false

  setTimer() {
    this.interval = setInterval(() => {
      this.countDown()
    }, 1000)
  }

  resetTimer(seconds) {
    clearInterval(this.interval)
    this.seconds = seconds
    this.interval = null
    this.timer = ''
    this.expired = false
  }

  countDown() {
    if (this.seconds >= 0) {
      this.timer = this.formatSeconds(this.seconds)
      this.seconds--
    } else {
      clearInterval(this.interval)
      this.expired = true
      this.interval = null
      this.timer = ''
    }
  }

  formatSeconds(secs) {
    function pad(n) {
      return (n < 10 ? '0' + n : n)
    }

    const h = Math.floor(secs / 3600)
    const m = Math.floor(secs / 60) - (h * 60)
    const s = Math.floor(secs - h * 3600 - m * 60)

    return pad(m) + ':' + pad(s)
  }

}
